/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Try to decode an error into a message and a stack.
 * @param error
 */
export const decodeError = (error: unknown): { message: string; stack?: string } => {
  if (typeof error === 'function' && 'toString' in error) {
    return { message: error.toString() };
  }

  if (typeof error === 'number' || typeof error === 'boolean') {
    return { message: error.toString() };
  }

  if (typeof error === 'string') {
    return { message: error };
  }

  if (typeof error === 'object' && error !== null) {
    if (error instanceof Error) {
      return { message: error.message, stack: error.stack };
    }

    if ('message' in error && 'stack' in error) {
      return {
        message: (error as any).message as string,
        stack: (error as any).stack as string,
      };
    }

    if ('message' in error) {
      return { message: (error as any).message as string };
    }
  }

  try {
    return { message: JSON.stringify(error) };
  } catch {
    return { message: error as string };
  }
};
